import { registerSettingComponent, registerWidget } from "dmeditor";
import definition from "./definition";
import { Markdown } from "./Markdown";

const register = () => {
  registerWidget(definition, {
    render: Markdown,
  });
};

export default register;
